'use strict';
angular.module('TurneroApp').component('coAsistencia', {
	bindings: {
		centroAtencionSeleccionado: '<'
	},
	controller: [
	  '$window',
	  'turnosService',
	  '$state',
	  '$rootScope',
	  '$scope',
	  'TurneroAppConstant',
	  'seguridadService',
	function ($window, turnosService, $state, $rootScope, $scope, TurneroAppConstant, seguridadService) {
		var ctrl = this;

		ctrl.limpiarMemoria = function () {
			ctrl.ConsultaTurnos = true;
		}
		ctrl.$onInit = function () {
			ctrl.telefonico = ($state.current.url == TurneroAppConstant.url.Consulta_Telefonico);
			ctrl.centroAtencionSeleccionado = ctrl.telefonico ? null : ctrl.centroAtencionSeleccionado;
			ctrl.limpiarMemoria();
		};

		ctrl.$onChange = function () {
			ctrl.centroAtencionSeleccionado = seguridadService.permisos.contains(ctrl.permisos.Dar_Turnos_Telefonicos) ? null : ctrl.centroAtencionSeleccionado;
			ctrl.telefonico = seguridadService.permisos.contains(ctrl.permisos.Dar_Turnos_Telefonicos);
			ctrl.limpiarMemoria();
		};

		var ctrl = this;
		ctrl.permisos = TurneroAppConstant.Permisos;
		ctrl.mostrarFiltro = true;
		ctrl.atencionEnCursoConsulta = true;
		ctrl.turnosConsulta = true;
		ctrl.turnoDetalles = false;
		ctrl.btnCancelar = false;
		ctrl.CancelarTurnos = {};
		ctrl.motivos_cancelacion = {};
		ctrl.dateHoy = new Date;

	}],
	template: require('./asistencia_consultaTurno.html')
});



// WEBPACK FOOTER //
// ./app/components/asistencia/asistencia_consultaTurnoComponent.js